const STORAGE_KEY = "khromatik_cookie_consent";
const CONSENT_VERSION = 1;
const GA_MEASUREMENT_ID = "G-0LV6HK0X2B";
const CLARITY_ID = "w61ru1fkg6";

let analyticsInjected = false;

export function assetBase() {
  return /\/projects\//.test(location.pathname) ? "../" : "./";
}

function parseConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data.v !== CONSENT_VERSION) return null;
    if (typeof data.analytics !== "boolean") return null;
    return data;
  } catch {
    return null;
  }
}

function saveConsent(analytics) {
  const payload = {
    v: CONSENT_VERSION,
    analytics,
    savedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

function updateGtagConsent(granted) {
  if (typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
  });
}

function injectClarity() {
  if (window.clarity) return;
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
}

function injectGa() {
  if (analyticsInjected) return;
  analyticsInjected = true;

  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src =
    "https://www.googletagmanager.com/gtag/js?id=" + GA_MEASUREMENT_ID;
  document.head.appendChild(gtagScript);

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);

  injectClarity();
}

export function applyStoredConsent() {
  const consent = parseConsent();
  if (consent?.analytics) {
    updateGtagConsent(true);
    injectGa();
  }
  return consent;
}

function wirePolicyLink() {
  const el = document.getElementById("cookie-banner-policy");
  if (el) {
    el.href = `${assetBase()}impressum.html#cookies`;
  }
}

function getBannerEls() {
  const root = document.getElementById("cookie-consent-banner");
  if (!root) return null;
  return {
    root,
    accept: document.getElementById("cookie-consent-accept"),
    reject: document.getElementById("cookie-consent-reject"),
  };
}

function showBanner() {
  const els = getBannerEls();
  if (!els) return;
  els.root.hidden = false;
  els.root.setAttribute("aria-hidden", "false");
}

function hideBanner() {
  const els = getBannerEls();
  if (!els) return;
  els.root.hidden = true;
  els.root.setAttribute("aria-hidden", "true");
}

function onAccept() {
  saveConsent(true);
  updateGtagConsent(true);
  injectGa();
  hideBanner();
}

function onReject() {
  saveConsent(false);
  updateGtagConsent(false);
  hideBanner();
}

function wireBanner() {
  const els = getBannerEls();
  if (!els) return;
  els.accept?.addEventListener("click", onAccept);
  els.reject?.addEventListener("click", onReject);
}

function wireFooterTrigger() {
  const btn = document.getElementById("cookie-settings-trigger");
  if (!btn) return;
  btn.addEventListener("click", () => showBanner());
}

export function openCookiePreferences() {
  showBanner();
}

export function initCookieConsent() {
  if (typeof window.gtag !== "function") {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("consent", "default", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      wait_for_update: 500,
    });
  }

  wirePolicyLink();
  wireBanner();
  wireFooterTrigger();

  const consent = parseConsent();
  if (consent === null) {
    showBanner();
  } else if (consent.analytics) {
    updateGtagConsent(true);
    injectGa();
  }
}

window.openCookiePreferences = openCookiePreferences;
